import { api_v2 as api } from "@/api/axios.config"
import type { CompanyProfileAPIResponse, CompanyProfilePayload } from "../types"
import { toSnake } from "@/utils/caseConverter"

export const getCompanyProfile = async () => {
  const res = await api.get("/app/company")
  return { ...res, data: toSnake(res.data.data) as CompanyProfileAPIResponse }
}

export const updateCompanyProfile = async (data: Partial<CompanyProfilePayload>) => {
  return api.post("/app/company", data)
}

export const getIBGECities = async (uf: string) => {
  const response = await fetch(
    `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios?orderBy=nome`
  )
  return response.json() as Promise<{ id: number; nome: string }[]>
}

export const uploadCompanyImage = async (uid: string, file: File) => {
  const formData = new FormData()
  formData.append("foto", file)
  const res = await api.post(`/media/imagem-emp/uid/${uid}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  })
  return { ...res, data: { url: res.data.data?.url as string } }
}

/**
 * Converte string de array PostgreSQL para array JS.
 * Ex: '{"1","12","5"}' → ["1", "12", "5"]
 * Ex: '{"teste1","teste2"}' → ["teste1", "teste2"]
 */
export function parsePgArray(value: string | null | undefined): string[] {
  if (!value || typeof value !== "string") return []
  const inner = value.replace(/^\{/, "").replace(/\}$/, "")
  if (!inner) return []
  return inner.split(",").map((item) => item.replace(/^"/, "").replace(/"$/, ""))
}
